import { DisbursementType } from '../config/registrationConfig'
import useGlobalContext from './useGlobalContext'
import { useMemo } from 'react'

type ReturnProps = {
    loaded: boolean
    disbursementTypes: DisbursementType[]
    getDisbursementType: (id: string) => DisbursementType
}

export default function useDisbursementTypes(): ReturnProps {
    const { loaded, entities } = useGlobalContext('disbursementTypes')

    const disbursementTypes: DisbursementType[] = useMemo(
        () => entities?.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())) || [],
        [entities],
    )
    const getDisbursementType = (id: string) => disbursementTypes.find(value => value.id === id)

    return { loaded, disbursementTypes, getDisbursementType }
}
